import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-cycle
import { Error } from '@nextgen/frontend-components-organisms';
import { useTranslations } from '../hooks/IntlProvider/useTranslations';


const PageNotFound = ({ errorMessageId, homepageButtonId, headingId }) => {
  const { messages } = useTranslations('pageNotFound');
  return (
    <Error
      errorMessage={messages[errorMessageId]}
      buttonText={messages[homepageButtonId]}
      headingText={messages[headingId]}
    />
  );
};

PageNotFound.defaultProps = {
  errorMessageId: 'pageNotFound.message',
  homepageButtonId: 'pageNotFound.button',
  headingId: 'pageNotFound.heading'
};

PageNotFound.propTypes = {
  errorMessageId: PropTypes.string,
  homepageButtonId: PropTypes.string,
  headingId: PropTypes.string
};

export default PageNotFound;
